export const renderLayerCount = ({ red_layer, blue_layer, green_layer, yellow_layer }: any) => {
  const layers = [red_layer?.id, blue_layer?.id, green_layer?.id, yellow_layer?.id].filter(Boolean);
  return layers?.length || 0;
}

export const formatDate = (isoDate: string): string => {
  return new Date(isoDate).toLocaleString();
}